<!-- 新增修改联系人、企业账户通用弹窗 -->
<template>
    <el-dialog class="formDialog" :model-value="dialogVisible" :title="title" width="900px" @close="handleClose"
        :show-close="false" append-to-body>
        <div class="imgBox"><img src="@/assets/account/default.png" /></div>
        <div class="flexForm">
            <el-form v-if="dialogVisible" ref="ruleFormRef" :model="formModel" :rules="getRules()" label-width="120px"
                status-icon>
                <el-form-item :label="$t('also.last name')" prop="first_name">
                    <!-- 按中国的习惯来 -->
                    <el-input v-model="formModel.first_name" :disabled="isDisabled('first_name')" />
                </el-form-item>
                <el-form-item :label="$t('also.first name')" prop="last_name">
                    <el-input v-model="formModel.last_name" :disabled="isDisabled('last_name')" />
                </el-form-item>
                <el-form-item :label="$t('page.user.account')" prop="username">
                    <el-input v-model="formModel.username" :disabled="isDisabled('username')" />
                </el-form-item>
                <el-form-item :label="$t('page.user.role')" prop="role_id">
                    <!-- 禁止编辑 -->
                    <el-input v-if="isDisabled('role_id')" :model-value="getRoleItem(formModel.role_id).name"
                        :disabled="true" />
                    <role-select v-show="!isDisabled('role_id')" :type="type"
                        :belong_type="formModel.belong_type || belong_type || null" :value="formModel.role_id"
                        @changed="changeRole" :invalid="false" @loaded="loadedRoleList"></role-select>
                </el-form-item>
                <el-form-item :label="$t('page.user.phone')" prop="tel">
                    <el-input v-model="formModel.tel" :disabled="isDisabled('tel')" />
                </el-form-item>
                <el-form-item :label="$t('page.user.email')" prop="email">
                    <el-input v-model="formModel.email" :disabled="isDisabled('email')" />
                </el-form-item>

                <!-- 设备联系人字段 -->
                <template v-if="isDeviceContact">
                    <el-form-item :label="$t('page.user.department')" prop="department">
                        <el-input v-model="formModel.department" :disabled="isDisabled('department')" />
                    </el-form-item>
                    <el-form-item :label="$t('page.user.position')" prop="position">
                        <el-input v-model="formModel.position" :disabled="isDisabled('position')" />
                    </el-form-item>
                    <el-form-item :label="$t('page.user.label')" prop="tags">
                        <Multiselect :value="tagsFormat" @change="changeLabel" mode="tags" :searchable="true"
                            :caret="false" :create-tag="true" :show-options="false" :options="tagsFormat"
                            :disabled="isDisabled('tags')" />
                    </el-form-item>
                </template>

            </el-form>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="handleClose">{{ $t('base.cancel') }}</el-button>
                <el-button type="primary" :disabled="loading" @click="confirm">{{ $t('base.confirm') }}</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>

import RoleSelect from "@/views/widgets/role-select";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { flatTreeList } from '@/utils/common'
import { ElMessage } from 'element-plus'
import { errorMsg } from "@/helpers/swal";

import {
    createUserAccount,
    createOrganizationAccount,
    patchUserAccount,
    patchOrganizationAccount,
} from "@/service";

export default {
    name: 'addUpdateAccountDialog',
    components: {
        RoleSelect,
        Multiselect
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        formData: {
            type: Object,
            default() {
                return {}
            }
        },
        title: {
            type: String,
            default: '默认标题',
        },
        formType: { // 表单类型，add 新增｜edit 修改
            type: String,
            default: 'add',
            validator(value) {
                return ['add', 'edit'].includes(value)
            }
        },
        disabledFields: { // 需要禁用的字段数组
            type: Array,
            default() {
                return []
            }
        },
        // #region 角色获取相关
        type: {
            type: String,
            default: 'user', // user-普通用户 organization-企业用户
            validator(value) {
                return ['user', 'organization'].includes(value)
            }
        },
        belong_type: {
            type: String,
            default: null,
        },
        defaultRoleCode: { // 默认选中的角色类型 - 将默认选中对应角色下拉中的code项对应的id
            type: String,
            default: null,
        }
        //#endregion 角色获取相关
    },
    emits: ['update:visible', 'successed'],
    data() {
        return {
            dialogVisible: false,
            formModel: {},
            loading: false,
            flatRoleList: [] // 扁平化后的角色下拉
        }
    },
    mounted() {
    },
    watch: {
        visible: {
            handler(newVal) {
                if (newVal) {
                    this.dialogVisible = newVal
                    this.init()
                }
            },
            immediate: true
        }
    },
    computed: {
        // label 对应的控件值改为数组类型
        tagsFormat() {
            let vl = this.formModel.tags || []
            return !Array.isArray(vl) ? vl.split(',') : vl
        },
        createAccount() {
            if (this.type === 'user') {
                return createUserAccount
            } else {
                return createOrganizationAccount
            }
        },
        patchAccount() {
            if (this.type === 'user') {
                return patchUserAccount
            } else {
                return patchOrganizationAccount
            }
        },
        // 当前角色是否是设备联系人
        isDeviceContact() {
            let rs = this.flatRoleList || []
            if (!rs.length) return false
            return (rs.find(item => item.id === this.formModel.role_id) || {}).code === 'device_contact'
        }
    },
    methods: {
        // 当前值是否禁止编辑
        isDisabled(field) {
            if (!field) return true
            return this.disabledFields.includes(field)
        },
        // 验证规则
        getRules() {
            let rules = {
                last_name: [
                    { required: true, message: this.$t('base.required'), trigger: 'change' },
                ],
                first_name: [
                    { required: true, message: this.$t('base.required'), trigger: 'change' },
                ],
                username: [
                    { required: true, message: this.$t('base.required'), trigger: 'change' },
                ],
                role_id: [
                    { required: true, message: this.$t('base.required'), trigger: 'change' },
                ],
                tel: [
                    { required: true, message: this.$t('base.required'), trigger: 'change' },
                ],
                email: [
                    { required: true, message: this.$t('base.required'), trigger: 'change' },
                    {
                        type: 'email',
                        message: '请输入正确的邮箱',
                        // Please input correct email address
                        trigger: 'change',
                    },
                ],
            }
            return rules
        },
        init() {
            // 变量初始化
            this.roleList = []
            this.formModel = {
                ...this.formData
            }
            // this.$nextTick(() => {
            //     this.$refs['ruleFormRef'].clearValidate()
            // })
        },
        handleClose() {
            this.dialogVisible = false
            this.$emit('update:visible', false)
        },
        // 确定
        confirm() {
            this.$refs['ruleFormRef'].validate((valid, fields) => {
                if (!valid) {
                    console.log('error submit!', fields)
                    return
                }
                // console.log('submit!')

                this.loading = true
                if (this.formType === 'add') { // 新增
                    let params = {
                        ...this.formModel,
                        kc_account_id: new Date().getTime()
                    }
                    this.createAccount(params).then((res) => {
                        if(this.type == 'organization' && res.payload&&res.payload.message&&res.payload.message == "USER_EXISTS"){//账号重名
                            errorMsg(this.$t('base.duplicate_name'))
                            return;
                        }

                        ElMessage({
                            message: this.$t('base.add_success'),
                            grouping: true,
                            type: 'success',
                        })
                        this.handleClose()
                        this.$emit('successed')
                    }).catch(err => {
                        console.log(err)
                    }).finally(() => {
                        this.loading = false
                    })
                } else { // 修改
                    let params = {
                        ...this.formModel,
                    }
                    this.patchAccount(params).then(() => {
                        ElMessage({
                            message: this.$t('base.modified_successfully'),
                            grouping: true,
                            type: 'success',
                        })
                        this.handleClose()
                        this.$emit('successed')
                    }).catch(err => {
                        console.log(err)
                    }).finally(() => {
                        this.loading = false
                    })
                }
            })
        },
        // 标签修改 - 因为控件是数组类型的，后端需要的是string类型
        changeLabel(val) {
            this.formModel.tags = val.join(',') // 存储到后端是string类型的
        },
        // #region 角色相关
        changeRole(value) {
            this.formModel.role_id = value || ''
        },
        // 角色列表加载完成
        loadedRoleList(list) {
            this.flatRoleList = flatTreeList(list, 'sub') || [] // 扁平化角色下拉
            if(this.defaultRoleCode){ // 需要默认选中角色
                this.changeRole(this.getRoleItem(this.defaultRoleCode, 'code').id)
            }
        },
        // 获取选中的角色信息
        getRoleItem(val, field = 'id') {
            return this.flatRoleList.find(item => item[field] === val) || {}
        }
        //#endregion 角色相关
    }
}
</script>

<style lang="scss" scoped>
.imgBox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;

    img {
        width: 106px;
        height: auto;
        border-radius: 50%;
    }
}

.flexForm {
    :deep(.el-form) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 0 10px;
        /*  声明行的高度  */
        // grid-template-rows: 50px;
        justify-content: space-between;

        .el-form-item__label {
            justify-content: flex-start;
        }

        .el-form-item {
            display: flex;
            width: 100%;
            flex-direction: column;

            &:nth-child(odd) {
                margin-right: 10px;
            }

            .el-select {
                width: 100%;
            }
        }
    }
}
</style>
<style lang="scss">
.formDialog {
    .el-dialog__header {
        background-color: rgba(41, 156, 219, 0.18);
        color: rgba(33, 37, 41, 1);
        font-weight: bold;
        margin-right: 0;
    }

    .el-button--primary {
        --el-button-hover-border-color: rgba(67, 82, 133, 0.8);
        --el-color-primary: rgba(67, 82, 133, 1);
        --el-button-hover-bg-color: rgba(67, 82, 133, 0.8);
    }
}
</style>